import { IS_BINARY } from '@/constants';
import { useEffect } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

let navigateRef: NavigateFunction | null = null;

/**
 * Navegação SPA para login após 401. Interceptors não têm acesso a `useNavigate()`; este componente (montado dentro do
 * Router) registra a função aqui.
 */
export function navigateToLoginExpired() {
  if (IS_BINARY) {
    window.location.hash = '#/flow/desktop/sign-in';
    return;
  }

  if (navigateRef) {
    navigateRef('/auth/sign-in', { replace: true });
    return;
  }

  window.location.assign('/auth/sign-in');
}

export function AppNavigationBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    navigateRef = navigate;
    return () => {
      navigateRef = null;
    };
  }, [navigate]);

  return null;
}
